import images from "@/assets/images";
import Button from "@/components/Button";
import TiltedCard from "@/components/TiltedCard";
import Constants from "@/constants";
import { useAnimationTime } from "@/hooks";
import { clickGeneralDownload } from "@/report";
import { downloadFile } from "@/utils";
import classnames from "classnames";

interface ITVComponentProps {
  isBigScreen?: boolean;
}
const TVComponent: React.FC<ITVComponentProps> = ({ isBigScreen }) => {
  if (isBigScreen)
    return (
      <div className="flex h-full items-center justify-between">
        <Left className="ml-[100px] mr-[7.56vw] shrink-0" />
        <Right className="mr-[100px] w-full" />
      </div>
    );

  return (
    <div className="mt-[48px]">
      <Left className="mb-[40px] ml-[106px]" />
      <div className="mx-[106px]">
        <Right className="w-full min-w-[600px]" />
      </div>
    </div>
  );
};

interface ILeftProps {
  className?: string;
}
const Left: React.FC<ILeftProps> = ({ className }) => {
  const { isAnimationFirst } = useAnimationTime();
  return (
    <div
      className={classnames(
        "content-wrap-animation",
        className,
        !isAnimationFirst && "!ani-delay-0",
      )}
    >
      <div className={classnames("title-animation", !isAnimationFirst && "!ani-delay-0")}>
        <div className="mb-[12px] flex w-max items-center justify-center rounded-[4px] bg-[#FFFFFF0D] text-[#FFFFFF99] max-text-[12px] max-leading-[22px] max-px-[12px] max-py-[4px]">
          TV客户端
        </div>
        <p className="text-[#FFF] max-text-[42px] max-leading-[42px]">虎牙直播客户端</p>
        <p className="mt-[20px] text-[#fff] max-text-[52px] max-leading-[52px]">沉浸享受精彩直播</p>
      </div>

      <div
        className={classnames(
          "version-animation my-[20px] flex items-center text-[#FFFFFF99] max-text-[12px] max-leading-[22px]",
          !isAnimationFirst && "!ani-delay-0",
        )}
      >
        <div
          className="flex cursor-pointer items-center"
          onClick={() => {
            window.open("https://tv.huya.com/");
          }}
        >
          <p>安装教程</p>
          <img src={images.iconRight} className="u-max-w-[16px] u-max-h-[16px]" />
        </div>
      </div>
      <div
        className={classnames("download-button-animation", !isAnimationFirst && "!ani-delay-300")}
      >
        <Button
          className="bg-primary u-max-w-[200px] u-max-h-[52px]"
          onClick={() => {
            downloadFile(Constants.DOWNLOAD_URL.TV);
            clickGeneralDownload({
              button_name: "立即下载",
              product_name: "2",
            });
          }}
        >
          <p className="font-[500] text-[#0B0B0B] max-text-[18px]">立即下载</p>
        </Button>
      </div>
    </div>
  );
};

interface IRightProps {
  className?: string;
}
const Right: React.FC<IRightProps> = ({ className }) => {
  const { isAnimationFirst } = useAnimationTime();
  return (
    <TiltedCard
      className={classnames("product-animation", className, !isAnimationFirst && "!ani-delay-150")}
      imageSrc={images.PC3}
      rotateAmplitude={8}
      scaleOnHover={1.05}
      showMobileWarning={false}
      showTooltip={false}
      displayOverlayContent={false}
    />
  );
};

export default TVComponent;
